export const paginationMap: GenericObject = {
	meta: {
		current_page: "currentPage",
		last_page: "lastPage",
		per_page: "perPage",
	},
};
